// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"141":"bbfaf67d","209":"b45647b7","787":"7eee6f6d","829":"df0b8fdc","878":"c9250848"}[chunkId] + ".chunk.js";
};